/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Type_Price_Below_ThresholdInputs */

const he_notifications_type_price_below_threshold = /** @type {(inputs: Notifications_Type_Price_Below_ThresholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ירידה מתחת למחיר יעד`)
};

const en_notifications_type_price_below_threshold = /** @type {(inputs: Notifications_Type_Price_Below_ThresholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Below Target`)
};

/**
* | output |
* | --- |
* | "Price Below Target" |
*
* @param {Notifications_Type_Price_Below_ThresholdInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_type_price_below_threshold = /** @type {((inputs?: Notifications_Type_Price_Below_ThresholdInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Type_Price_Below_ThresholdInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_type_price_below_threshold(inputs)
	return en_notifications_type_price_below_threshold(inputs)
});